
var sprite = require("/home/romain/Cozy/cozy-proxy/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 52 52\" id=\"icon-lock_f8fade66ed90d42e6c4d0f86e660fc4c\" ><title>icon-lock</title><path d=\"M49 26c0 12.704-10.298 23-23 23C13.296 49 3 38.704 3 26 3 13.298 13.296 3 26 3c12.702 0 23 10.298 23 23zm-16-6c0-3.868-3.134-7-7-7-3.868 0-7 3.132-7 7 0 2.774 1.616 5.164 3.954 6.296L21 39h10l-1.956-12.704C31.382 25.164 33 22.774 33 20z\" stroke=\"#FFF\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></symbol>";
module.exports = sprite.add(image, "icon-lock_f8fade66ed90d42e6c4d0f86e660fc4c");


//////////////////
// WEBPACK FOOTER
// ./app/assets/sprites/icon-lock.svg
// module id = 96
// module chunks = 0